import script from "./AttendancePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AttendancePage.vue?vue&type=script&setup=true&lang=js"

import "./AttendancePage.vue?vue&type=style&index=0&id=d13922e6&lang=css"

const __exports__ = script;

export default __exports__